import { safeDefine } from "../../registration/safe-define.js";
import { ScaffoldAudioSkinElement } from "../../presets/audio/scaffold-skin.js";
import "../../internal/skins/scaffold-audio/register.js";
//#region src/define/audio/scaffold-skin.ts
safeDefine(ScaffoldAudioSkinElement);
//#endregion

//# sourceMappingURL=scaffold-skin.js.map